import React, { Component } from 'react';
import Submit from '../component/Submit.js';
import SelectBox from '../component/Select.js';
import Input from '../component/Input.js';
import Validation from './Validation.js'; //used for validating input
import PropTypes from 'prop-types';

export default class Prize extends Component{
	constructor(props){
		super(props);
		this.state = {prize:this.props.prize, size:'N/A', color:'N/A',photo:'',quantity:1, total:'',variations:[],button:true};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSelection = this.handleSelection.bind(this);
		this.handleSize = this.handleSize.bind(this);
		this.handleQuantity = this.handleQuantity.bind(this);
	}

	handleSize(identity,value){ //method that handles changing the size of a prize, and setting the correct first color and its respective picture
		let variants = this.state.variations;
		const theState = {};
		theState[identity] = value;
		for(let i = 0;i<variants.length;i++){
			if(variants[i].size===value){
				// Convert color to use spaces to match SelectBox options
				let firstColor = variants[i].colors[0];
				if (firstColor !== "N/A" && firstColor !== null && firstColor !== undefined) {
					firstColor = firstColor.replace(/_/g, " ");
				}
				theState['color'] = firstColor; //set first color of prize
				theState['photo'] = variants[i].photos[0]; //set picture for first color
			}
		}
		this.setState(theState);
	}

	handleSelection(identity,value){  //method for handling user input for colors, displays corresponding image of the color selected
		let variants = this.state.variations;
		const theState = {};
		theState[identity] = value;
		for(let i = 0; i<variants.length; i++){
			if (variants[i].size === this.state.size){
				for(let j = 0; j<variants[i].colors.length; j++){
					if(variants[i].colors[j] === value){
						theState['photo'] = variants[i].photos[j];
					}
				}
			}
		}
		this.setState(theState);
	}

	handleQuantity(identity,value){ //handles user input for quantity of prize they would like to add to shopping cart
		if(/^(\s*|[1-9][0-9]*)$/.test(value)){ //only allow positive integers
			const theState = {};
			theState[identity] = value;
			this.setState(theState);
		}
	}

	handleSubmit(){ //method for passing up prize information to be added to the shopping cart
		if(this.state.quantity !== ''){
			let price = this.props.price;
			let quant = this.state.quantity === undefined || this.state.quantity === null || (Number(this.state.quantity) < 1)?1:this.state.quantity;
			const getTotal = (x,y) =>{
				return (Number(x)*Number(y));
			}
			const total = getTotal(price,quant); //get total cost based on quantity and unit price
			this.setState({total:total,button:false}, function(){ //on click, add button displays "Added!" for half a second
				setTimeout(()=>{
					this.setState({button:true});
				},500);
				let s = this.state;
				let size = s.size === 'Select'?'N/A':s.size;
				let color = s.color === 'Select'?'N/A':s.color;
				let lineItem = {prize:s.prize,size:size,color:color,quantity:Number(quant),total:s.total};
				this.setState
				this.props.onChoice(lineItem); //pass up gift information
				this.setState({quantity:1});
			});
		}
	}

	componentDidMount(){ //when component mounts, loop through prize/variant information and match colors and photos to each size
		let allsizes = [];
		let variations = [];
		this.props.variants.forEach((variant)=>{
				allsizes.push(variant.size);
		});
		let sizes = allsizes.filter((v, i, a) => a.indexOf(v) === i);
		let firstcolor;
		let firstphoto;
		let firstsize;
		for(let i = 0;i<sizes.length;i++){ //outer for loop loops through each size in the array sizes
			variations.push({size:sizes[i],colors:[],photos:[]}); //push objects to variations, colors array is for colors that correspond with each single size
			for(let j = 0;j<this.props.variants.length;j++){ //loop through each variant to compare each size to variant
				if(sizes[i] === this.props.variants[j].size){ //if the size matches the size in the variations array of objects, add the color to the colors array
					variations[i].colors.push(this.props.variants[j].color);
					variations[i].photos.push(this.props.variants[j].photo);
				}
			}
			if (sizes[i] === null || sizes[i] === undefined || sizes[i] === ''){
				variations[i].size = "N/A";
			}
			if(variations[i].colors.length === 0 || variations[i].colors[0] === undefined || variations[i].colors[0] == null || variations[i].colors[0] === ''){
				firstcolor = "N/A";
				firstphoto = variations[i].photos[0];
				firstsize = variations[i].size;
			}else{
				firstcolor = variations[0].colors[0];
				firstphoto = variations[0].photos[0];
			}
		}
		let theFirst = variations[0];
		// Convert firstcolor to use spaces to match SelectBox options
		let displayColor = firstcolor;
		if (firstcolor !== "N/A" && firstcolor !== null && firstcolor !== undefined) {
			displayColor = firstcolor.replace(/_/g, " ");
		}
		this.setState({variations:variations,color:displayColor,photo:firstphoto,price:this.props.price,size:theFirst.size});
	}

	render(){
		const picstyles = {
			width:'auto',
			height:'auto',
			margin:'auto',
			display:'inline-block',
			maxHeight:'122px'
		};
		const containerDivStyle = {
			minWidth:'260px',
			minHeight:'375px',
			boxShadow:'1px 1px 4px 4px #aaaaaa',
			maxWidth:'315px',
			margin:'auto',
			textAlign:'center'
		};
		const imgDivStyle = {
			maxWidth:'100px',
			width:'100px',
			height:'122px',
			maxHeight:'122px',
			textAlign:'center',
			margin:'auto',
			overflow:'hidden',
			paddingBottom: '20px',
		};
		const labelStyle = "ml5";
		const selectStyle = "w-60 mv1 mr3 pa1 shadow-2 br2 b--gray bw1 tc";
		const labelDivStyle = "fl w-50 tl mt2 b gray";
		const selectDivStyle = "fl w-50 tl pl2";
		const minHeightStyle = {minHeight:'38px'};
		const borderstyle = "br3 bg-white"//:"bb br b--light-silver ba br3 mb2 ma2 bg-white bw1";(this.props.child) % 3 === 0 ?
		let theButton = <Submit name="Add" onClick={this.handleSubmit} styles="bg-dark-blue white b br3 grow bn shadow-3 h2 w-20-ns mt2"/>;
		if(!this.state.button){ //message displayed in place of add button, on click, for half a second
			theButton = <div className="pt4 mt4"><p className="tc mb0 pt4 pb0"><span className="mt4 b navy">Added!</span></p></div>;
		}
		let size=[];
		let colors =[];
		let theColors = [];
		const vari = this.state.variations;
		vari.forEach((variation)=>{
				size.push(variation.size);
		});
		let selectSize;
		let selectColor;
		if(size[0] === "N/A"){ //if there are no size options, only display color options
			selectSize = <p className="b mt1 mb1 pt1 pb2">N/A</p>;
			colors = this.state.variations[0].colors;
			colors.forEach((color)=>{
				if(color === null || color === undefined || color === ''){
					color = "N/A";
				}else{
					color = color.replace(/_/g," ");
				}
				theColors.push(color);
			});
			if(colors.length === 1 && colors[0] === "N/A"){
					selectColor = <p className="b mt1 mb1 pt1 pb2">N/A</p>;
				}else{
					selectColor = <SelectBox name="color" identity="color" onSelect={this.handleSelection} options={theColors} styles={selectStyle} val={this.state.color}/>;
				}
		}else{ //if there are color options, consolidate them based on the selected size
			selectSize = <SelectBox name="size" identity="size" onSelect={this.handleSize} options={size} styles={selectStyle} val={this.state.size}/>;
				//let theColors = [];
				vari.forEach((variant)=>{
					if(variant.size === this.state.size){
						colors = variant.colors;
						colors.forEach((color)=>{
							if(color === null|| color === undefined || color === ''){
								color = "N/A";
							}else{
								theColors.push(color.replace(/_/g," "));
							}
						});
					}
				});
				if(colors.length === 1 && colors[0] === "N/A"){
					selectColor = <p className="b mt1 mb1 pt1 pb2">N/A</p>;
				}else{
					selectColor = <SelectBox name="color" identity="color" onSelect={this.handleSelection} options={theColors} styles={selectStyle} val={this.state.color}/>;
				}
			
		}
		if(this.state.color === "N/A" && this.state.size === "N/A"){
			selectColor = <p className="b mt1 mb1 pt1 pb2">N/A</p>;
		}
		let imgpath = this.props.path + this.state.photo;
		imgpath = imgpath.replace(/\s/g,"_");
		return(
			<div className={borderstyle} style={containerDivStyle}>
				<div className="tc" style={{minHeight:'204px'}}>
					<div className="w-100" style={{minHeight:'64px', maxHeight:'64px'}}>
						<p className="mt0 pt2 b navy fl tc w-20"></p>
						<p className="mt0 pt2 b underline navy tc fl w-60">{this.props.prize} </p>
						<p className="mt0 pt2 b navy fl tc w-20"><span className="dark-red">{this.props.price} </span><span className="navy"> pts</span></p>
					</div>
					<div className="w-100 prize_image_container">
						<div style={imgDivStyle}>
							<img src={imgpath} alt="error" style={picstyles}/>
						</div>
					</div>
				</div>
				<div className="mb3 pb">
					<div className="w-100 mw6 center">
						<div className="w-100">
							<div className={labelDivStyle}>
								<label className={labelStyle}>Size:</label>
							</div>
							<div className={selectDivStyle} style={minHeightStyle}>
								{selectSize}
							</div>
						</div>
						<div className="w-100">
							<div className={labelDivStyle}>
								<label className={labelStyle}>Color:</label>
							</div>
							<div className={selectDivStyle}>
								{selectColor}
							</div>
						</div>
					</div>
					<div className="w-100 mw-100 center">
						<div className={labelDivStyle}>
							<label className={labelStyle}>Quantity:</label>
						</div>
						<div className={selectDivStyle}>
							<Input name="quantity" identity="quantity" onInput={this.handleQuantity} inputStyle={selectStyle} val={this.state.quantity} type="number"/>
						</div>
					</div>
				</div>
				<div className="mv3 pt3">
					{theButton}
				</div>
			</div>
		);
	}
}

Prize.propTypes = {
	prize: PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
	price: PropTypes.number.isRequired,
	variants: PropTypes.array.isRequired,
	onChoice: PropTypes.func.isRequired,
	child: PropTypes.number.isRequired
}


// WEBPACK FOOTER //
// ./src/container/Prize.js